import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { injectIntl } from 'src/decorator/inject-intl';
import Base from 'src/core/base';

interface Prop {}
interface State {}

@(withRouter as any)
@injectIntl()
export default class Header extends Base<Prop, State> {
    constructor(props: any) {
        super(props);
    }

    goHomeHandler = () => {
        this.props.history?.goBack();
    };

    componentDidMount() {}

    render() {
        return (
            <div className="m-hd">
                <div className="m-topBar">
                    <a className="goback" onClick={this.goHomeHandler}>
                        <FormattedMessage id="go-back" />
                    </a>
                </div>
            </div>
        );
    }
}
